import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const FullLoader = () => (
  <div className="flex min-h-[50vh] items-center justify-center" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-brand" />
  </div>
);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
};
